const formatMultipleAnswer = (currentAnswer, answerId, value) => {
  const foundIndex = currentAnswer.findIndex((answer) => answer.value === value);

  return foundIndex === -1
    ? [...currentAnswer, { answerId, value }]
    : [...currentAnswer.slice(0, foundIndex), ...currentAnswer.slice(foundIndex + 1)];
};

export default formatMultipleAnswer;
